import { Box, Button, FormHelperText } from "@mui/material"
import { useState } from "react"
import DlspDesktopAssessmentForm from "./DlspDesktopAssessmentForm"
import { DesktopAssessmentDetails } from "./DesktopAssessmentDetails"

export function DlspDesktopAssessmentPanel({taskDetails, assignee, onEdited}) {
    const [isEditing, setIsEditing] = useState(false)

    const desktopAssessmentButtonLabel = taskDetails?.decomICP?.desktopChecklist
        ? "Edit Desktop Assessment"
        : "Create Desktop Assessment"

    const handleAssessmentFormEdited = () => {
        setIsEditing(false)
        onEdited() // tell parent the assessment form has been editied (even though it might just have been closed)
    }

    const isDesktopAssessmentEditDiabled = !["Desktop", "Desktop QA"].includes(taskDetails?.decomICP?.status)

    return (
        <Box>
            {
                isEditing
                ?
                <DlspDesktopAssessmentForm
                    assessmentDetails={taskDetails?.decomICP?.desktopChecklist}
                    icpNumber={taskDetails?.decomICP?.icp}
                    assignee={assignee}
                    onClose={handleAssessmentFormEdited}
                    />
                :
                <>
                    <DesktopAssessmentDetails
                        desktopChecklist={taskDetails?.decomICP?.desktopChecklist}
                        inspectedBy={taskDetails?.decomICP?.desktopInspBy}
                        inspectionDate={taskDetails?.decomICP?.desktopInspDate}
                    />
                    <Button variant="contained" sx={{my:1}} color="primary" onClick={() => setIsEditing(true)} disabled={isDesktopAssessmentEditDiabled} >
                        {desktopAssessmentButtonLabel}
                    </Button>
                    {
                        isDesktopAssessmentEditDiabled
                        &&
                        <FormHelperText>Editing is allowed for Desktop and Desktop QA status</FormHelperText>
                    }
                </>
            }
        </Box>
    )
}
